"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commandEnvelopeSchema = exports.updateTriggerSchema = exports.createTriggerSchema = exports.triggerCatalogEntrySchema = exports.triggerChannelSchema = exports.triggerSeveritySchema = exports.triggerCategorySchema = void 0;
const zod_1 = require("zod");
exports.triggerCategorySchema = zod_1.z.enum([
    "safety",
    "security",
    "maintenance",
    "compliance",
    "productivity",
    "notifications",
    "operational",
    "business",
    "environmental",
    "driver-behavior",
]);
exports.triggerSeveritySchema = zod_1.z.enum(["low", "medium", "high", "critical"]);
exports.triggerChannelSchema = zod_1.z.enum(["email", "sms", "push", "webhook", "in-app"]);
exports.triggerCatalogEntrySchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string().optional(),
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    category: exports.triggerCategorySchema,
    severity: exports.triggerSeveritySchema,
    signals: zod_1.z.array(zod_1.z.string()),
    // Older backends may omit this field and only send `channels`.
    defaultChannels: zod_1.z.array(exports.triggerChannelSchema).default([]),
    aiPolicyLink: zod_1.z.string().nullable().optional(),
    createdAt: zod_1.z.string().datetime().optional(),
    updatedAt: zod_1.z.string().datetime().optional(),
    enabled: zod_1.z.boolean().optional(),
    priority: zod_1.z.enum(["P0", "P1", "P2", "P3"]).optional(),
    tier: zod_1.z
        .enum(["standard", "advanced", "premium", "enterprise", "custom"])
        .optional(),
    channels: zod_1.z.array(exports.triggerChannelSchema).optional(),
    // Extended fields used by the comprehensive trigger catalog.
    threshold: zod_1.z.unknown().optional(),
    cooldownSeconds: zod_1.z.number().int().nonnegative().optional(),
    actions: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    settings: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
})
    .passthrough();
exports.createTriggerSchema = exports.triggerCatalogEntrySchema
    .omit({ id: true, createdAt: true, updatedAt: true })
    .extend({ tenantId: zod_1.z.string() });
exports.updateTriggerSchema = exports.triggerCatalogEntrySchema
    .partial()
    .extend({ id: zod_1.z.string() });
exports.commandEnvelopeSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    deviceId: zod_1.z.string(),
    type: zod_1.z.string(),
    payload: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    correlationId: zod_1.z.string().nullable().optional(),
    priority: zod_1.z.enum(["LOW", "NORMAL", "HIGH"]).default("NORMAL"),
    status: zod_1.z.enum(["QUEUED", "DISPATCHED", "FAILED", "COMPLETED"]),
    createdAt: zod_1.z.string().datetime(),
    executeAt: zod_1.z.string().datetime().nullable().optional(),
    completedAt: zod_1.z.string().datetime().nullable().optional(),
    updatedAt: zod_1.z.string().datetime().optional(),
})
    .strict();
